export default "__VITE_ASSET__f22d3abc__"